import { render, staticRenderFns } from "./News.vue?vue&type=template&id=19deb7c0&"
import script from "./News.vue?vue&type=script&lang=coffee&"
export * from "./News.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports